import { render, staticRenderFns } from "./purchaseReceivingHistory.vue?vue&type=template&id=7ffb6b4e&scoped=true"
import script from "./purchaseReceivingHistory.vue?vue&type=script&lang=js"
export * from "./purchaseReceivingHistory.vue?vue&type=script&lang=js"
import style0 from "./purchaseReceivingHistory.vue?vue&type=style&index=0&id=7ffb6b4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffb6b4e",
  null
  
)

export default component.exports